export function convertDataToQueryString(data) {
  let queryString = "";
  for (const [key, value] of Object.entries(data)) {
    // Check if the query parameter is present in the request
    if (value !== undefined && value !== null) {
      const param = `${key}=${value}`;

      // Check if the query string already contains parameters
      if (queryString.length > 0) {
        queryString += `&${param}`;
      } else {
        queryString += `${param}`;
      }
    }
  }
  return queryString;
}
